module.exports = __webpack_public_path__ + "static/media/SF-8-A.838120a3.mp3";